<script lang="ts" setup>
  import { useField } from 'vee-validate';
  import { toRef } from 'vue';
  import type { TextFormFieldProps } from './types';
  import { TextField, FieldWrapper } from '@/shared/ui/fields';

  const props = defineProps<TextFormFieldProps>();
  const { value, handleBlur } = useField(
    toRef(props, 'name'),
    undefined,
    props.options,
  );
</script>

<template>
  <div class="flex flex-col relative w-full bg-transparent border-none p-0">
    <field-wrapper :class="innerClasses">
      <text-field
        v-bind="{ ...$attrs, ...props }"
        v-model="value"
        @blur="handleBlur"
      >
        <template v-for="(_, name) in $slots" #[name]="data">
          <slot :name="name" v-bind="data" />
        </template>
      </text-field>
      <slot name="icon">
        <base-icon
          v-if="iconName"
          :name="iconName"
          size="w-4 h-4"
          :class="iconClasses"
        />
      </slot>
    </field-wrapper>
    <div v-if="error" class="text-sm text-red-500">
      {{ error }}
    </div>
  </div>
</template>
